import { useTranslation } from 'react-i18next'

import { CaretRight } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import ProgressBar from '../ProgressBar/ProgressBar'
import * as Styles from './styles'

const Reason = ({ reason, index, barColor, textBarColor, showCount = true, onClick }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container onClick={onClick}>
      <Text type="bodyMRegular" color={theme.colors.text.subtle}>
        {index}
      </Text>
      <Styles.InfoContainer>
        <Styles.ReasonTextContainer>
          <Text type="titleS">{reason?.display}</Text>
          <Text type="bodySRegular" color={theme.colors.text.subtle}>
            {reason?.base_return_reason}
          </Text>
        </Styles.ReasonTextContainer>
        <Styles.ProgressBarAndCountContainer>
          <ProgressBar progress={Number(reason?.percentage)} barColor={barColor} textColor={textBarColor} />
          {showCount && (
            <>
              <Text type="bodyMRegular">{t('Total')}:</Text>
              <Text type="titleS">
                <FormatNumber style="decimal">{reason?.count}</FormatNumber>
              </Text>
            </>
          )}
        </Styles.ProgressBarAndCountContainer>
      </Styles.InfoContainer>
      {typeof onClick === 'function' && (
        <Styles.NavigationContainer>
          <CaretRight size={24} />
        </Styles.NavigationContainer>
      )}
    </Styles.Container>
  )
}

export default Reason
